"use strict";

var _regeneratorRuntime = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/regenerator/index.js");

var _defineProperty = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/defineProperty.js");

var _asyncToGenerator = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/createClass.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var innedit_1 = require("@innedit/innedit");

var innedit_type_1 = require("@innedit/innedit-type");

var Produit = /*#__PURE__*/function () {
  function Produit() {
    _classCallCheck(this, Produit);
  }

  _createClass(Produit, null, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
        var channelId, espaceId, produitData, produit;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                channelId = String(process.env.GATSBY_ID_CHANNEL);
                espaceId = String(process.env.GATSBY_ID_BOUTIQUE);

                if (espaceId) {
                  _context.next = 4;
                  break;
                }

                throw new Error('espaceId obligatoire');

              case 4:
                produitData = new innedit_1.ProduitData({
                  espaceId: espaceId
                });
                _context.next = 7;
                return produitData.findById(id);

              case 7:
                produit = _context.sent;

                if (!(!produit.channels || !produit.channels[channelId] || !produit.channels[channelId].isVisible)) {
                  _context.next = 10;
                  break;
                }

                throw new Error("Le produit n'est pas disponible");

              case 10:
                return _context.abrupt("return", _objectSpread({
                  id: id
                }, (0, innedit_type_1.convertProduitTypeToNode)(produit)));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "calculNewQuantity",
    value: function calculNewQuantity(qty, oldQty, item) {
      var hasInventory = item.hasInventory,
          qtyAvailable = item.qtyAvailable,
          qtyMin = item.qtyMin,
          qtyByNumber = item.qtyByNumber,
          qtyMax = item.qtyMax;

      if (0 === qty) {
        return 0;
      }

      var addOp = qty > oldQty;
      var newQtyByNumber = qtyByNumber || 1;
      var newQtyMin = qtyMin ? Math.max(1, qtyMin, newQtyByNumber) : newQtyByNumber;
      var newQtyMax;

      if (hasInventory) {
        newQtyMax = qtyMax || 0;
      } else {
        newQtyMax = 1;
      }

      var newQty = qty || newQtyMin;
      newQtyMax -= newQtyMax % newQtyByNumber > 0 ? newQtyMax % newQtyByNumber : 0;

      if (newQty % newQtyByNumber > 0) {
        newQty -= newQty % newQtyByNumber;
        newQty += addOp ? newQtyByNumber : 0;
      }

      if (newQtyMin && newQty < newQtyMin) {
        newQty = newQtyMin;
      }

      if (newQtyMax > 0 && newQty > newQtyMax) {
        newQty = newQtyMax;
      }

      if (hasInventory && qtyAvailable && newQty > qtyAvailable) {
        newQty = qtyAvailable;
      }

      return newQty;
    }
  }, {
    key: "search",
    value: function () {
      var _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(q, options) {
        var espaceId, produitModel, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                espaceId = String(process.env.GATSBY_ID_BOUTIQUE);
                produitModel = new innedit_1.ProduitData({
                  espaceId: espaceId
                });
                _context2.next = 4;
                return produitModel.search(q, options);

              case 4:
                result = _context2.sent;
                return _context2.abrupt("return", {
                  hits: result.hits.map(function (hit) {
                    return _objectSpread({
                      id: hit.objectID
                    }, (0, innedit_type_1.convertProduitTypeToNode)(hit));
                  }),
                  nbHits: result.nbHits
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function search(_x2, _x3) {
        return _search.apply(this, arguments);
      }

      return search;
    }()
  }, {
    key: "secureUpdate",
    value: function secureUpdate(id, datas) {
      var espaceId = String(process.env.GATSBY_ID_BOUTIQUE);
      var produitModel = new innedit_1.ProduitData({
        espaceId: espaceId
      });
      return produitModel.secureUpdate(id, datas);
    }
  }, {
    key: "watch",
    value: function () {
      var _watch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id, next) {
        var channelId, espaceId, channelData, channel, produitModel;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                channelId = String(process.env.GATSBY_ID_CHANNEL);
                espaceId = String(process.env.GATSBY_ID_BOUTIQUE);
                channelData = new innedit_1.ChannelData({
                  espaceId: espaceId
                });
                _context4.next = 5;
                return channelData.findById(channelId);

              case 5:
                channel = _context4.sent;
                produitModel = new innedit_1.ProduitData({
                  espaceId: espaceId
                });
                return _context4.abrupt("return", produitModel.watchById(id, /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(snapshot, metadata) {
                    var _a, _b, _c, _d, prices;

                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return produitModel.findPrices(id);

                          case 2:
                            prices = _context3.sent;
                            next(snapshot ? _objectSpread({
                              id: id
                            }, (0, innedit_type_1.convertProduitTypeToNode)(snapshot, {
                              prices: prices,
                              priceDisplayMode: (_a = channel.produits) === null || _a === void 0 ? void 0 : _a.priceDisplayMode,
                              priceVariation: (_b = channel.produits) === null || _b === void 0 ? void 0 : _b.priceVariation,
                              tarification: (_d = (_c = channel.produits) === null || _c === void 0 ? void 0 : _c.tarification) !== null && _d !== void 0 ? _d : 'public'
                            })) : undefined, metadata);

                          case 4:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x6, _x7) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function watch(_x4, _x5) {
        return _watch.apply(this, arguments);
      }

      return watch;
    }()
  }]);

  return Produit;
}();

exports.default = Produit;